import {AppDownloadBanner} from 'components/AppDownloadBanner';
import {RestrictedCountriesBanner} from 'components/RestrictedCountriesBanner';
import {LayoutProvider} from 'contexts/LayoutContext';
import {GlobalStyle} from 'global.styles';
import {Footer} from 'layouts/Footer';
import React from 'react';
import styled, {ThemeProvider} from 'styled-components';
import {Header} from './Header';
import {Breadcrumbs} from 'components/Breadcrumbs';
import {useI18next} from 'gatsby-plugin-react-i18next';
import {getPrismicPageAlternates} from 'utils/hreflang';

type LayoutProps = {
  path: string;
  pageContext: any;
  data?: any;
};

const theme = {
  boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
  borderRadius: '3px'
};

const Wrapper = styled.div`
  overflow-x: hidden;
`;

const Layout: React.FC<LayoutProps> = ({children, pageContext, data, ...rest}) => {
  const {languages, defaultLanguage} = useI18next();
  const isNewLayout: boolean =
    pageContext.i18n.originalPath.match(
      /affiliate|notification-preferences|inactive-survey|subscribe|complaint/
    ) || pageContext.i18n.originalPath.match(/contact-sales/);

  const flatLanding: boolean =
    pageContext.i18n.originalPath.match(/sem-esp/) ||
    pageContext.i18n.originalPath.match(/ecommerce-billing/);

  // Prismic-sourced pages (blog posts/categories under /blog/:uid/, plus
  // /page/:uid/ and /author/:uid/, see gatsby-config.js) shouldn't get the
  // banner — only our own landing pages should.
  const isPrismicPage: boolean = Boolean(
    pageContext.i18n.originalPath.match(/^\/(page|author)\//) ||
    pageContext.i18n.originalPath.match(/^\/blog\/.+/)
  );

  return (
    <ThemeProvider theme={theme}>
      <LayoutProvider>
        <AppDownloadBanner />
        {!isPrismicPage && <RestrictedCountriesBanner />}
        <Wrapper>
          <>
            <GlobalStyle />
            {!flatLanding && <Header isNewLayout={isNewLayout} />}
            <Breadcrumbs />
            {/*This span avoids weird navigation issue that puts the footer on top of the header*/}
            <span style={{display: 'none'}}> </span>
            {children}
            {!flatLanding && (
              <Footer
                hideCTA={isNewLayout}
                // Prismic docs only exist in some languages; don't link to missing translations.
                langAlternates={getPrismicPageAlternates({data, defaultLanguage, languages})}
              />
            )}
          </>
        </Wrapper>
      </LayoutProvider>
    </ThemeProvider>
  );
};

export default Layout;
